import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaWhatsapp,
} from "react-icons/fa";

function Contact() {
  return (
    <section
      id="contact"
      className="py-16 md:py-20 lg:py-24 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">

        {/* Heading */}

        <div className="text-center mb-12 lg:mb-16">

          <p className="text-green-700 uppercase font-semibold tracking-[4px] text-sm md:text-base">
            Contact Us
          </p>

          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800">
            Get In <span className="text-green-700">Touch</span>
          </h2>

          <p className="mt-5 text-gray-600 max-w-3xl mx-auto leading-8 text-base md:text-lg px-2">
            Looking for fresh coconuts or bulk orders? We'd love to hear from you.
            Contact us today for premium-quality coconut products directly
            from our farm.
          </p>

          <div className="w-24 h-1 bg-green-700 rounded-full mx-auto mt-6"></div>

        </div>

        {/* Main Content */}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">

          {/* Contact Form */}

          <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-8 lg:p-10">

            <h3 className="text-2xl lg:text-3xl font-bold mb-8 text-gray-800">
              Send Us a Message
            </h3>

            <form className="space-y-5">

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">

                <input
                  type="text"
                  placeholder="Your Name"
                  className="border border-gray-300 rounded-xl px-5 py-4 outline-none focus:ring-2 focus:ring-green-600"
                />

                <input
                  type="text"
                  placeholder="Phone Number"
                  className="border border-gray-300 rounded-xl px-5 py-4 outline-none focus:ring-2 focus:ring-green-600"
                />

              </div>

              <input
                type="email"
                placeholder="Email Address"
                className="w-full border border-gray-300 rounded-xl px-5 py-4 outline-none focus:ring-2 focus:ring-green-600"
              />

              <select
                className="w-full border border-gray-300 rounded-xl px-5 py-4 outline-none focus:ring-2 focus:ring-green-600"
              >
                <option>Select Product</option>
                <option>Fresh Coconut</option>
                <option>Tender Coconut</option>
                <option>Copra</option>
                <option>Coconut Oil</option>
                <option>Coconut Leaves</option>
                <option>Coconut Shell</option>
              </select>

              <textarea
                rows="6"
                placeholder="Write your message..."
                className="w-full border border-gray-300 rounded-xl px-5 py-4 outline-none focus:ring-2 focus:ring-green-600 resize-none"
              ></textarea>

              <button
                className="w-full bg-green-700 hover:bg-green-800 text-white py-4 rounded-xl text-lg font-semibold transition duration-300"
              >
                Send Message
              </button>

            </form>

          </div>

          {/* Contact Info */}

          <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-8 lg:p-10">

            <h3 className="text-2xl lg:text-3xl font-bold mb-8 text-gray-800">
              Contact Information
            </h3>

            <div className="space-y-6">

              {/* Phone */}

              <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-green-50 transition">

                <div className="w-14 h-14 rounded-full bg-green-700 flex items-center justify-center text-white flex-shrink-0">
                  <FaPhoneAlt />
                </div>

                <div>

                  <h4 className="font-semibold text-lg">
                    Phone
                  </h4>

                  <p className="text-gray-600 mt-1">
                    +91 99945 48118
                  </p>

                </div>

              </div>

              {/* Email */}

              <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-green-50 transition">

                <div className="w-14 h-14 rounded-full bg-green-700 flex items-center justify-center text-white flex-shrink-0">
                  <FaEnvelope />
                </div>

                <div>

                  <h4 className="font-semibold text-lg">
                    Email
                  </h4>

                  <p className="text-gray-600 mt-1 break-all">
                    gowthamv187@gmail.com
                  </p>

                </div>

              </div>

              {/* Address */}

              <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-green-50 transition">

                <div className="w-14 h-14 rounded-full bg-green-700 flex items-center justify-center text-white flex-shrink-0">
                  <FaMapMarkerAlt />
                </div>

                <div>

                  <h4 className="font-semibold text-lg">
                    Address
                  </h4>

                  <p className="text-gray-600 mt-1 leading-7">
                    DV Coconut Farms
                    <br />
                    Krishnagiri
                    <br />
                    Tamil Nadu, India
                  </p>

                </div>

              </div>

              {/* Working Hours */}

              <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-green-50 transition">

                <div className="w-14 h-14 rounded-full bg-green-700 flex items-center justify-center text-white flex-shrink-0">
                  <FaClock />
                </div>

                <div>

                  <h4 className="font-semibold text-lg">
                    Working Hours
                  </h4>

                  <p className="text-gray-600 mt-1 leading-7">
                    Monday - Saturday
                    <br />
                    8:00 AM - 6:00 PM
                  </p>

                </div>

              </div>

            </div>

            {/* WhatsApp */}

            <a
              href="https://wa.me/919994548118"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 flex items-center justify-center gap-3 bg-green-600 hover:bg-green-700 text-white py-4 rounded-xl text-lg font-semibold transition duration-300"
            >

              <FaWhatsapp size={22} />

              Chat on WhatsApp

            </a>

          </div>

        </div>

      </div>
    </section>
  );
}

export default Contact;